import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { StoreProptypes } from "../../PropTypes/StoreProptypes";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";

interface PropTypes {
    setChangeWidgetMobileVisibility: Function // function to set updated widget size
}

// component to render widget size settings
const WidgetVisibility = (props: PropTypes) => {

    // Props
    const { setChangeWidgetMobileVisibility } = props;

    // Redux Data
    const { currentWebsite } = useSelector((store: StoreProptypes) => store);

    // Functions
    const { t } = useTranslation();

    // States
    const [widgetMobileVisibility, setWidgetMobileVisibility] = useState<number>(0);


    useEffect(() => {
        // check if current website is available
        if (currentWebsite) {
            // check if widget size is set to 1
            if (currentWebsite.mobile_visibility === 1) {
                setWidgetMobileVisibility(1);
            } else {
                setWidgetMobileVisibility(0);
            }
        }
    }, [currentWebsite]);


    useEffect(() => {
        // check widget size is set to 1
        if (widgetMobileVisibility === 1) {
            setChangeWidgetMobileVisibility(1);
        } else {
            setChangeWidgetMobileVisibility(0);
        }
    }, [widgetMobileVisibility]);


    return (
        <>
            <div className="aioa_dashboard-widget-settings-btns">
                <Button onClick={() => setWidgetMobileVisibility(1)} className={`${widgetMobileVisibility === 1 ? 'active' : ''}`} size="lg">{t('Show on Mobile Devices')}</Button>
                <Button onClick={() => setWidgetMobileVisibility(0)} className={`${widgetMobileVisibility === 0 ? 'active' : ''}`} size="lg">{t('Hide on Mobile Devices')}</Button>
            </div>
        </>
    )
}

export default WidgetVisibility;